export default "__VITE_ASSET__DniwkGQV__"